import { Pipe, PipeTransform } from "@angular/core";

/**
 * Pipe utilizado para substituir a url do zabbix conforme link
 */
@Pipe({ name: "zabbixUrlFormatter" })
export class ZabbixUrlFormatterPipe implements PipeTransform {

    transform(link: string, itemId: string): string {
        const zabbixPlaceholder = "${zabbixUrl}"; //NOSONAR //Ignorado no sonar pois é o formato necessário para esse pipe

        return link ? link.replace(zabbixPlaceholder, itemId) : "";
    }
}
